import { render, staticRenderFns } from "./toc-item.vue?vue&type=template&id=3412a516"
import script from "./toc-item.ts?vue&type=script&lang=src&external"
export * from "./toc-item.ts?vue&type=script&lang=src&external"
import style0 from "./toc-item.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports